import {Route,Switch,BrowserRouter } from "react-router-dom";

import VehiclesTable from "components/Doobi/Vehicles";
import DoobiHeader from "components/Headers/DoobiHeader";

const VehiclesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Vehicles" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={VehiclesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default VehiclesRoute;
